export default __webpack_public_path__ + "static/media/IMG_2850 copie.193be3bf.jpg";